import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'orwi-store-bonus',
  templateUrl: './store-bonus.component.html',
  styleUrls: ['./store-bonus.component.scss'],
})
export class StoreBonusComponent implements OnInit {

  @Input() bonus: number
  constructor() { }

  ngOnInit() {}

}
